<template>
  <div class="sidebar">
    <AmazonTransparencyIcon class="transparency-logo"/>
    <div  @click="goToTab('products')"  class="sidebar-btn d-flex align-center" :class="{ active: selected === 'products' }">
      <ProductsIcon :color="selected === 'products' ? '#00a1ec' : 'black'" class="mr-3"/>
      <span class="sidebar-text text-capitalize">{{ $t('amazon_transparency_products') }}</span>
    </div>

    <div @click="goToTab('transactions')" class="sidebar-btn d-flex align-center" :class="{ active: selected === 'transactions' }">
      <v-icon size="24" :color="selected === 'transactions' ? 'primary' : 'black'" class="mr-3">mdi-swap-vertical-bold</v-icon>
      <span class="sidebar-text text-capitalize">{{ $t('amazon_transparency_tbya_transactions') }}</span>
    </div>

    <div @click="goToTab('config')" class="sidebar-btn d-flex align-center" :class="{ active: selected === 'config' }" v-if="isAdmin">
      <v-icon size="24" :color="selected === 'config' ? 'primary' : 'black'" class="mr-3">mdi-security</v-icon>
      <span class="sidebar-text text-capitalize">{{ $t('amazon_transparency_config') }}</span>
    </div>
  </div>
</template>

<script>
import AmazonTransparencyIcon from '@/components/icons/AmazonTransparencyIcon.vue'
import ProductsIcon from '@/components/icons/ProductsIcon.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'Navigation',
  components: {
    AmazonTransparencyIcon,
    ProductsIcon
  },
  computed: {
    ...mapGetters(['isAdmin'])
  },
  props: ['selected'],
  methods: {
    goToTab (tab) {
      console.log('tab', tab)
      const currentTab = this.$route.name
      const targetTab = `amazon-transparency.${tab}`

      if (currentTab !== targetTab) {
        this.$router.push({ name: targetTab, params: { id: this.$route.params.id } })
      }
    }
  }
}
</script>

<style lang="sass">

@import "@/variables.sass"

.transparency-logo
  margin-bottom: 40px
  margin-top: 20px

.sidebar
  background: #f1f1f1
  width: 278px
  height: 100vh
  padding: 20px 24px
  margin-right: 24px

  .sidebar-btn
    cursor: pointer
    margin-bottom: 24px

    &.active
      color: $primary

    .sidebar-text
      display: block
      white-space: nowrap
      font-size: 20px
      font-style: normal
      font-weight: 400
      line-height: normal

@media (max-width: 768px)
  .sidebar
    width: 62px
    padding: 20px 12px

  .sidebar-btn .mr-3
    margin-right: 0 !important

  .sidebar-text
    display: none !important

  .transparency-logo
    display: none !important

@media (min-width: 769px)
  .sidebar-text
    display: inline-block !important
</style>
